export default {
	sec_01: {
		title: {
			one: 'ビジネス決済と資金',
			two: 'アクセス',
		},
		desc: {
			one: 'JP WORLD PAYと一緒なら手軽な送金、支出、移動時の',
			two: 'ビジネス取引が可能です。',
		},
		btn: {
			one: '会員登録',
			two: '営業チームに問い合わせ',
		},
	},
	sec_14: {
		desc: {
			one: 'あなたのビジネスに高度にカスタマイズ可能な商取引ソリューションが必要ですか？',
		},
		btn: ' 企業向けのJP WORLD PAYについて学ぶ。',
	},
	sec_03: {
		title: {
			one: '便利にお買い求めください',
		},
		desc: {
			one: 'JP WORLD PAYの残高を使 ってオンラインおよびビジネス費用を直接お支払いください',
		},
		one: {
			title: {
				one: 'お支払いのみの場合',
			},
			desc: {
				one: '資金を電子的に送信して時間と労力を節約しましょう。',
			},
			btn: {
				one: '送金方法を学ぶ',
			},
		},
		two: {
			title: {
				one: 'お支払い',
			},
			desc: {
				one: '同時に複数の人と場所へ簡単に送金',
				two: 'することができます',
			},
			btn: {
				one: '販売代金の詳細',
			},
		},
		three: {
			title: {
				one: '今日、',
				two: '始める',
			},
			desc: {
				one: 'JP WORLD PAYを使っている販売者と一緒に。',
			},
			btn: {
				one: 'ビジネスアカウントの登録',
			},
		},
	},
	sec_07: {
		title: {
			one: 'Please check',
			two: 'the notes',
		},
		list: {
			one: '1. JP WORLD PAYでお金を管理して使うためには、JP WORLD PAYビジネスアカウントまたはJP WORLD PAY残高アカウントが必要です。',
			two: {
				one: '2. JP WORLD PAY Business Debit BlockChainを購入する際にボーナスキャッシュバックを受け取ることができる取引は次の通りです。(1)あなたが署名し、ブロックチェーンカードが処',
				two: '理するクレジット取引、(2)キャッシュバックの提案を受けることができない取引の現金の引き出し、',
				three: '(3)現金サービスで処理される取引またはPINを使用した取引',
				four: 'JP WORLD PAY Business Debit BlockChainは、JP WORLD PAYから発行します。カードはBlockChainが、JP WORLD PAYが通用するすべてのことろでご利用いただけます。JP WORLD PAYはカード発行者で',
				five: 'あり、JP WORLD PAY関連のアカウントやその他の製品、サービスまたは提案について責任を負いかねます。',
			},
		},
	},
	common: {
		coming_soon: '準備中です。',
	},
};
